// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__kGF+j","content":"layout_content__PuUGz"};